import axios from "axios";
import { ADMIN_API_BASE_URL, ADMIN_DESIGNATION, ADMIN_DORMMITORY, ADMIN_EMPLOYEE, ADMIN_EMPLOYEE_GET, ADMIN_TEAM, ADMIN_COMPANY, ADMIN_PROJECT, ADMIN_TRUCK_TRIP, ADMIN_ATTENDANCE, ADMIN_WORKER_PAYROLL, ADMIN_DRIVER_PAYROLL, ADMIN_EMPLOYEE_PAY_LIST, ADMIN_ADVANCE, ADMIN_ADVANCE_ADD, ADMIN_TRUCK_TRIP_VIWE, ADMIN_SALARY_DETAILS_ADD, ADMIN_SALARY_DETAILS, ADMIN_TRUCK_TRIP_PUT, ADMIN_SALARY_PUT, ADMIN_ATTENDANCE_PUT, ADMIN_EMPLOYEE_ATTENDANCE_REPORT, ADMIN_DORMITORY_DETAILS, ADMIN_EMPLOYEE_PAY_DETAILS, ADMIN_EMPLOYEE_PAY_ROLL, ADMIN_EMPLOYEE_PAYDETAIL_DATERANGE, ADMIN_EMPLOYEE_ATTENDANCE_REPORT_BY_DATE, ADMIN_TRUCK_TRIP_REPORT, ADMIN_TEAM_MEMBER_DETAILS } from "../Routes";


export const companyGet = async () => {
  try {
    // const routeURI = `${ADMIN_API_BASE_URL}${ADMIN_COMPANY}`;
    // console.log(`Route API : ${routeURI}`);
    
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_COMPANY}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const companyPost = async (post) => {
  console.log(post)
  try {
    console.log('NETWORK POST')
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_COMPANY}`, post);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error' }
  }
};

export const companyEdit = async (editPost, id) => {
  // console.log(`Inside API Call : ${id}`);
  // console.log(`API Edit Company: ${ADMIN_API_BASE_URL}${ADMIN_COMPANY}/${id} `); 
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_COMPANY}/${id}`, editPost);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error' }
  }
};

export const companyDelete = async (id) => {
  try {
    const response = await axios.delete(`${ADMIN_API_BASE_URL}${ADMIN_COMPANY}/${id}`)
    return response
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const teamGet = async () => {
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_TEAM}`);
    return response.data
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const teamPost = async (team) => {
  try {
   const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_TEAM}`, team);
   return response.data;
 } catch (err) {
   throw err.response ? err.response.data : { message: 'Network Error' }
 }
};

export const teamEdit = async (editPost, id) => { 
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_TEAM}/${id}`, editPost);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error' }
  }
};

export const teamDelete = async (id) => {
  try {
    const response = await axios.delete(`${ADMIN_API_BASE_URL}${ADMIN_TEAM}/${id}`)
    return response
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const projectGet = async () => {
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_PROJECT}`);
    return response.data
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const projectPost = async (post) => {
   try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_PROJECT}`, post);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const projectEdit = async (editPost, id) => {
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_PROJECT}/${id}`, editPost);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error' }
  }
};

export const projectDelete = async (id) => {
  try {
    const response = await axios.delete(`${ADMIN_API_BASE_URL}${ADMIN_PROJECT}/${id}`)
    return response
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error' }
  }
};

export const DesignationGet = async () => {
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_DESIGNATION}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
};

export const DesignationPost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_DESIGNATION}`, post);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
};

export const DesignationPut = async (editPost, id) => {
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_DESIGNATION}/${id}`, editPost);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
};

export const DesignationDelete = async (id) => {
  try {
    const response = await axios.delete(`${ADMIN_API_BASE_URL}${ADMIN_DESIGNATION}/${id}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
};

export const getDormitoryDetails = async () => {
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_DORMMITORY}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
}

export const employeePost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE}`, post);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
}

export const employeeGet = async (company) => {
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_GET}?company_id=${company}`);
    return response.data
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
}

export const employeeEdit = async (editPost, id) => {
  console.log(`EditPost: ${JSON.stringify(editPost)}`);
  
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE}/${id}`, editPost);
    return response.data
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
}

export const employeeDelete = async (id) => {
  try {
    const response = await axios.delete(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE}/${id}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { mesage: 'Network Error ' }
  }
}
// Truck Trip API

export const truckTripGetbyCompany = async (getData) => {
  const { company_id, trip_month } = getData;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_TRUCK_TRIP_VIWE}${company_id}&trip_month='${trip_month}'`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error '}
  }
}

export const truckTripPost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_TRUCK_TRIP}`, post, { headers: { "Content-Type": "application/json" } });
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error '}
  }
}

export const truckTripPut = async (selectedId, put) => {
  console.log(`Put data: ${put}`);
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_TRUCK_TRIP_PUT}${selectedId}`, put);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: "Network Error" }
  }
}

export const attendancePost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_ATTENDANCE}`, post)
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error '}
  }
}

export const employeePayrollPost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_WORKER_PAYROLL}`, post, { headers: { "Content-Type": "application/json" } });
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
};

export const driverPayrollPost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_DRIVER_PAYROLL}`, post, {
      headers: { "Content-Type": "application/json" }
    });
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

export const employeeAttendanceGetbyCompany = async (getData) => {
  const { company_id, att_month } = getData;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_ATTENDANCE}?company_id=${company_id}&att_month='${att_month}'`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

export const employeeAttendancePut = async (editId, putData) => {
  console.log(`selected ID: ${editId}`);
  console.log(`Put Data: ${JSON.stringify(putData)}`);
  
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_ATTENDANCE_PUT}${editId}`, putData);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

export const employeePayrollGetbyCompany = async (getData) => {
  console.log('Inside employee payroll');
  
  const { company_id, pay_month } = getData;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_PAY_LIST}${pay_month}&company_id=${company_id}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

// Advance API
export const employeeAdvanceGetbyCompany = async (getData) => {
  const { company_id, advance_month } = getData;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_ADVANCE}${company_id}&advance_month='${advance_month}'`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

export const employeeAdvancePostbyCompany = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_ADVANCE_ADD}`, post);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

// Salary Details Added

export const employeeSalaryDetailsPost = async (post) => {
  try {
    const response = await axios.post(`${ADMIN_API_BASE_URL}${ADMIN_SALARY_DETAILS_ADD}`, post);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

export const employeeSalaryDetailsGet = async (getData) => {
  const { company_id } = getData;
  console.log(`Salary details ${company_id}`);
  console.log(`Salary URi: ${ADMIN_API_BASE_URL}${ADMIN_SALARY_DETAILS}${company_id}`);
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_SALARY_DETAILS}${company_id}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error ' }
  }
}

export const employeeSalaryPut = async (employee, putData) =>{
  console.log(`Selected Employee: ${employee}`);
  console.log(`Inside the Put data: ${JSON.stringify(putData)}`);
  
  try {
    const response = await axios.put(`${ADMIN_API_BASE_URL}${ADMIN_SALARY_PUT}${employee}`, putData);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error '}
  }
}

export const employeeAttendanceReport = async (employeeData) => {
  const { company_id, emp_id, att_month } = employeeData
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_ATTENDANCE_REPORT}${company_id}&emp_id=${emp_id}&att_month=${att_month}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error '}
  }
}

export const employeeDormitoryReport = async () => {
    console.log('Inseide the API Function');
  try {
    console.log('Inseide the API Try');
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_DORMITORY_DETAILS}`);
    console.log('API Data Log', response);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : { message: 'Network Error '}
  }
}

export const employeeDetailsPayDetailsReport =async (startDate,endDate)=>{
  //const {startDate,endDate}=payDetails;
  try{
  const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_PAY_DETAILS}'${startDate}'&endDate='${endDate}'`)
  console.log('API Response log',response);
  return response.data;  
} catch(err){
    throw err.response?err.response.data:{message:"Network Error"}
  }
}

export const employeePayslipReport = async (payslipData) => {
  const { company_id, emp_id, pay_month } = payslipData;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_PAY_ROLL}${pay_month}&emp_id=${emp_id}&company_id=${company_id}`);
    return response.data;
  } catch (err) {
    throw err.response?err.response.data:{message:"Network Error"}
  }
}

export const employeePayRangeDetails = async (payRange) => {
  const { emp_id, startDate, endDate } = payRange;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_PAYDETAIL_DATERANGE}${startDate}&endDate=${endDate}&emp_id=${emp_id}`);
    return response.data;
  } catch (err) {
    throw err.response?err.response.data:{message:"Network Error"}
  }
}

export const employeeAdvanceReportByDate = async (dateRange) => {
  const { startDate, endDate } = dateRange;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_EMPLOYEE_ATTENDANCE_REPORT_BY_DATE}${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (err) {
    throw err.response?err.response.data:{message:"Network Error"}
  }
}

export const truckTripReport = async (dateRange) => {
  const { startDate, endDate } = dateRange;
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_TRUCK_TRIP_REPORT}${startDate}&endDate=${endDate}`);
    return response.data
  } catch (err) {
    throw err.response?err.response.data:{message:"Network Error"}
  }
}

export const teamMemberDeails = async () => {
  try {
    const response = await axios.get(`${ADMIN_API_BASE_URL}${ADMIN_TEAM_MEMBER_DETAILS}`);
    return response.data;
  } catch (err) {
    throw err.response?err.response.data:{message:"Network Error"}
  }
}